<template>
  <div class="content">
    <div style="height: .2rem"></div>
    <div style="width: 25%;height: 2rem;background-color: #fff;float: left;margin: .2rem .3rem"  v-for="(item,index) in personList" :key="index" @click="changePatient(index)">
      <div style="font-size: .36rem;text-align: right;width: 90%" class="select-no-label">
        <el-radio v-model="radio" :label="index"></el-radio>
      </div>
      <div style="text-align: center">
        <el-avatar :src="item.sex=='男'?'static/img/huanzhenan.png':'static/img/huanzhenv.png'"></el-avatar>
      </div>
      <div style="text-align: center;line-height: .6rem">
        {{item.clinic_patient_name}}
      </div>
    </div>
    <div style="width: 25%;height: 2rem;background-color: #fff;float: left;margin: .2rem .3rem;font-size: .88rem;text-align: center;line-height: 2rem;color: #bbb">
      <i class="el-icon-circle-plus-outline" @click="addCard"></i>
    </div>
  </div>
</template>

<script>
  import {getCardList} from '../../api/index'
    export default {
      data(){
        return{
          personList:[],
          radio:0
        }
      },
      created() {
        //修改标题
        document.title = '选择就诊人'
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        //获取就诊人列表
        getCardList({
          open_id:this.$storage.get('openid'),
          unionid:this.$storage.get('unionid')
        }).then(res=>{
          loading.close();
          this.radio = res.Data.findIndex((item) => item.id == this.$storage.get('patient').id)
          this.personList = res.Data
        })
      },
      methods:{
        //选择就诊人 并返回
        changePatient(index){
          this.$storage.set('patient',this.personList[index])
          this.$router.go(-1)
        },
        addCard(){
          this.$storage.remove('clinic_patient_name')
          this.$storage.remove('clinic_num')
          this.$router.push({path:'/addHealthCard'})
        }
      }
    }
</script>

<style scoped>
  .content{
    width: 100%;
    height: 100vh;
    background-color: #f4f4f4;
    font-size: .28rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/selectPerson.vue